import {View} from 'backbone';
import _template from 'dashboard/forms/app-workspace-dashboard.ejs';
import filtersView from 'dashboard/workspace-table-filters.ejs';
import Spinner from 'spin/spin';
import listService from 'ListService.js';
import appService from 'AppService.js';
import util from 'util/Util';
import workspaceCommon from 'WorkspaceTableCommon';
import commonService from 'CommonService';
import constants from 'Constants.js';
import appTemplates from './AppTemplateView.js';
import eventBus  from 'EventBus';
class AppWorkspaceView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;
        this.spinner = new Spinner();
        this.data = [];
        this.dataLoaded = false;

        if (!util.hasEventListener(eventBus._events, 'reloadTable')) {
            this.listenTo(eventBus, 'reloadTable', this.reloadTable);
        }

        sessionStorage.setItem('appTourTag', '');

        this.getAllData();

        this.events = {};
        
        return this;
    }    
    
    reloadTable(){
        this.getAllData(true);
    }

    getAllData(reload){
        const self = this;
        commonService.getAll("app").then((result) => {   
            self.data = [];

            if (result) {
                const apps = util.enforceArrayType(result);
                
                apps.forEach((app) => {
                    const permissions = !util.isEmpty(app["UserPermissionsXML"]) ? app["UserPermissionsXML"].Permissions: null
                    const instanceLink = permissions ? '<a class="instances" href="javascript:void(0)"> ' + app["@TotalInstances"] + ' </a>' : app["@TotalInstances"];              
                    self.data.push(
                        {
                            id: app["@id"],
                            name: app["@name"],
                            appName: { name: app["@name"], lastUpdate: app["@LastUpdateDate"] },
                            version: app["@Version"],
                            status: util.isTrue(app["@IsDeployed"]) ? "Published" : "Draft",
                            mobileEnabled: util.isTrue(app["@MobileEnabled"]) ? "Yes" : "No",
                            isPrivate: util.isTrue(app["@IsPrivate"]),
                            ownerName: app["@Owner"] || "Owner Name",
                            totalInstances: instanceLink,
                            appFunctions: {
                                permissions: permissions,
                                design: this.loadAppDesigner,
                                publish: this.publishApp,
                                link: this.openAppLink,
                                view: this.createInstance,
                                favorite: { val: util.isTrue(app["@IsFavorite"]), objType: constants.FORMS_PRIVATE_GROUP_TYPE },
                                contextMenu: ".table-context-menu",
                                linkId: app["@linkId"]                            
                            }
                        }
                    )
                });

                //self.data.sort((a, b) => Date.parse(b.appName.lastUpdate) - Date.parse(a.appName.lastUpdate));
            }

            self.dataLoaded = true;
            if (reload) {
                workspaceCommon.reloadTable(self.data, "App");
            }

        });
    }

    bindEvents(){
        const self = this;
        $(".new-app-options .new").on("click", ()=>{           
            if(self.newApp){
                self.newApp.dialog("close");
            }
            sessionStorage.setItem('appTourTag', '_tScratch');
            appService.createNewApp(self);
        });

        $(".new-app-options .template").on("click", () =>{
            
            if(self.newApp){
                self.newApp.dialog("close");
            }

            const appTemplate = new appTemplates({el:".template-gallery"});
            appTemplate.render();
        });
        
        $("#new-app").on("click", () =>{
            
            if(self.newApp){
                self.newApp.dialog("close");
            }

            self.newApp.dialog("open");
        });
    }   
    
    createAppTable(){
        
        
        const appsTable = $('#apps-table');       
        workspaceCommon.bindIconsEvents();
        const self = this;
       
        const startTable = () => {
            if(self.dataLoaded){
                appsTable.bootstrapTable({
                    pagination: true,
                    paginationParts: ['pageInfo', 'pageList'],
                    classes: 'table table-hover table-striped table-borderless',
                    columns: [{
                        field: 'id',
                        visible: false
                    },
                    {
                        field: 'name',
                        visible: false
                    },
                    {
                        field: 'isPrivate',
                        visible: false
                    },
                    {
                        field: 'appName',
                        title: 'App Name',
                        width: 400,
                        formatter: workspaceCommon.appNameFormatter
                    },
                    {
                        field: 'ownerName',
                        title: 'Owner'
                    },
                    {
                        field: 'version',
                        title: 'Version',
                        align: 'center'
                    },
                    {
                        field: 'status',
                        title: 'Status',
                        align: 'center'
                    },
                    {
                        field: 'mobileEnabled',
                        title: 'Mobile Enabled',
                        align: 'center'
                    },
                    {
                        field: 'totalInstances',
                        title: 'Total Instances',
                        events: instancesLink,
                        align: 'center'
                    },
                    {
                        field: 'appFunctions',
                        title: '',
                        align: 'center',
                        clickToSelect: false,
                        events: appOptionsEv,
                        formatter: workspaceCommon.iconFormatter
                    }],
                    data: self.data,
                    onDblClickRow: (rowData, $el, colCliked) => {
                        if(rowData.appFunctions.permissions){
                            self.openDetails(rowData.id)
                        }
                        else{
                            self.openSimpleView(rowData.id, rowData.name)
                        }
                    }
                });

                workspaceCommon.showScreen(self.data.length, "App");
                

                let paginationText = $(".pagination-info").text().replace("rows", "apps");
                $(".pagination-info").text(paginationText);
            }
            else{
                setTimeout(startTable, 50);
            }
        }
        startTable();        
    }

    openDetails(appId){
        const refreshButton = $('#pf-refresh-main-view');
        refreshButton.attr("data-appid", appId);
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.openDetailsView(appModel, "app");
        });
    }

    openSimpleView(appId, appName){
        const refreshButton = $('#pf-refresh-main-view');
        refreshButton.attr("data-appid", appId);
        commonService.getBasicModel(appId, appName, appService.createNewSimpleModel).then((appModel)=>{
            commonService.openSimpleView(appModel, "app");
        });
    }

    loadAppDesigner(appId){
        sessionStorage.setItem('appTourTag', ''); 
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.loadDesigner(appModel, "app");
        });
    }
   
    openAppLink(appId){
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.openLink(appModel.get("formId"), appModel.get("formName"), appModel);
        });       
    }

    publishApp(appId){
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.publishValidations(appModel, "app");
        }); 
        
    }

    createInstance(appId, isBasic, linkId){
        appService.createNewInstance(appId, null, isBasic, linkId);
    }

    deleteApp(appId){
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.delete(appModel, "app");
        });        
    }

    migrateApp(appId){
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.migrate(appModel, "app");
        });  
    }

    permissionsApp(appId){
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.permissions(appModel, "app");
        }); 
    }

    shareApp(appId){
        commonService.getModel(appId, "app", appService.createNewModel).then((appModel)=>{
            commonService.share(appModel, "app");
        }); 
    }

    render() {
        this.$el.html(this.template(this.model.toJSON()));

        $("#search-filters").html(filtersView);      
        this.newApp = util.newDashboardModal("#new-app-options-modal", {title: "Create New App", hideTitleBar: false, closeEsc: true, width: 'auto'});
            
        if (listService.accountSettings.license.UsedForms > 0) {
            this.createAppTable();
            
            const menu = [  { name: "App Details", fxClass: "details-app", style: "", fx: [this.openDetails, this.openSimpleView] },
                            { name: "Design", fxClass: "design-app", style: "", fx: this.loadAppDesigner },
                            { name: "Publish", fxClass: "publish-app", style: "", fx: this.publishApp },
                            null,
                            { name: "New Instance", fxClass: "new-instance", style: "", fx: this.createInstance },
                            { name: "Link", fxClass: "link-app", style: "", fx: this.openAppLink },
                            null,
                            { name: "Share", fxClass: "share-app admin-fx", style: "", fx: this.shareApp },
                            { name: "Permissions", fxClass: "permissions-app admin-fx", style: "", fx: this.permissionsApp },
                            { name: "Migrate", fxClass: "migrate-app admin-fx", style: "", fx: this.migrateApp },
                            null,
                            { name: "Delete", fxClass: "delete-app admin-fx", style: "color:#F01212", fx: this.deleteApp } ];
            
            workspaceCommon.buildTableContextMenu(menu, $(".table-context-menu"));
        }
        else {
            workspaceCommon.showScreen(0, "App");
        }

        this.bindEvents();
        workspaceCommon.bindSearchFilterEvents($("#apps-table"));

        this.delegateEvents();
        return this;
    }
}

export default AppWorkspaceView;